module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Three")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Helmut had a head like a bullet. He was completely bald in a dramatic way that conveyed defiance, arrogance, and possibly violence. His shiny scalp came to an amazing point so pronounced, so sharp, that Charlie was sure it could be used as a tool or weapon if properly applied. Charlie made it a point not to stare at his pointy head, though at times he couldn’t help himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Helmut,” he said when he walked into the office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut ignored Charlie’s extended hand. Instead, he nodded and motioned for him to sit. He then sat down behind Marken’s desk and opened a file.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How was your trip in?” Charlie asked. He had decided to take a casual approach, though both his arms were now growing numb. He jiggled them gently and glanced around the office. It was only then that he saw Marken sitting on the couch behind him, looking like Lee Harvey Oswald. Seated next to him was Julie from human resources. He jiggled his arms again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are we having a meeting?” Charlie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut ignored him. He carefully placed small, rectangular reading glasses over the bridge of his nose and started reading the file. When he glanced at Charlie over the rims, Charlie noticed that his starched white shirt was monogrammed. This surprised him. He had never seen Helmut in a monogrammed shirt before and he couldn’t take his eyes off the initials on the pocket: "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HJK")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We are making a change,” Helmut said in his accent, which sounded darkly foreign that morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stopped and fixed his green eyes on Charlie. On one level Charlie comprehended what he had just said, but on another level he did not. It was clear, though, that a response was expected, so Charlie asked, “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This past year has been a disaster,” Helmut continued. “On all accounts. We have no option. There is no leadership here. Things have gone from bad to worse.” He said all this in a horribly matter-of-fact way that made Charlie feel more ashamed than angry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think that’s completely accurate,” Charlie said. His voice was high and weightless. He looked back at Marken, who glared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not? Then please tell me one thing you’ve accomplished since heading this office.” He held up a finger. “Please. One thing. I would be very interested to know this information.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie looked at Helmut’s solitary finger and felt defeated. At that moment, he couldn’t think of anything other than Charlie’s Book Club.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry about this morning,” Charlie finally managed to say. “I’ve been working long hours and I’m running on empty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We all work long hours,” Marken said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie glanced back at him again. “Excuse me, Frank, but what are you doing here?” He turned to Helmut. “What are those two doing here, may I ask? Are we having a meeting?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut returned to his file. “The Southwest campaign was a disaster. The creative that you assured me, that you promised me, would be fresh and edgy, was flat. Your idea of that woman and that rat was preposterous.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t a rat,” Charlie said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut was referring to a short and very ill-fated campaign for Southwest Airlines featuring Paula Abdul and a cool-looking hamster that talked. The campaign had become something of a laughingstock within the industry and even though it wasn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exactly")]), _vm._v(" Charlie’s idea, the shrapnel from that bomb had hit him squarely in his vital organs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We couldn’t get Beyoncé,” he said. “She was too expensive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s no excuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t be creative director and run an agency.” Charlie immediately regretted saying this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut’s eyes flared. “You insisted on leading that pitch. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Insisted")]), _vm._v(" on it. You should have deferred to your creative team and kept out of the way. That rodent was ridiculous. You should have trusted your people. You were the manager, I placed you in charge. Instead, you took over the creative and stifled everyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never stifled anyone. As I explained before, I thought I had a clearer grasp of the client. I knew them. I knew where they had to go and what they should be saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut raised his hand. “Please, I don’t want to discuss that anymore. I’ve heard all of your rationalizations.” He cleared his throat. “Anyway, I could list a number of additional issues here, a number of things you have failed to deliver upon, but I would rather not. Unless you would like me to do so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t understand,” Charlie said, though he was beginning to, and clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As I said, we’re making a change.” Charlie couldn’t speak. “We have prepared a separation package for you. It is nonnegotiable. You were not general manager very long. Under the circumstances, it is the best we can do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie found his voice: “Separation package?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut set his jaw. “We’re making a change. We are terminating your employment here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Terminating my employ…” Charlie stopped and swallowed, then said, “That’s ridiculous, that’s crazy. You can’t fire me. That’s just not possible. That’s not an option.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut stared at Charlie without expression. “Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can’t fire me, Helmut. Come on. You can’t. Let’s be serious. You can’t come in here and fire me like…like I was someone else. I mean, it makes no sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut looked over at Marken and then back at Charlie. “Don’t make this more difficult than it has to be.” Rather than angry, he seemed embarrassed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Stop it right now, come on, let’s just stop this!” Charlie stood. “You can’t do this. I work too hard. Listen. I’m sorry about the Southwest pitch and that stupid hamster. And I’m sorry for some of the other things, the ‘fat’ memo. That was wrong, I realize that now. I made a mistake, a mistake. Everyone makes them. But I’ll make it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s too late for apologies,” Helmut said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Listen, I need more time. This place was a mess. You know that. Plus, the economy. No one has budgets. Everyone’s scared to spend money. Besides, I was making headway. I think we’re going to keep Odor Eaters.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please sit down. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie sat back down, his head ringing. The room, he noticed, was shrinking. All he could see was Helmut’s monogram. He licked his lips and put his hand over his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut assessed him. “Are you all right? Do you need water?” He looked Julie’s way. “He needs some water.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t need water.” Charlie closed his eyes and jiggled his arms again. “I just need to get back to work now,” he said quietly. “I have work to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re through here, Charlie,” Marken said. “We’re firing you. You’re done.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie whirled to face him. “Shut up!” he sputtered. “You just shut up. You’re nothing but overhead, you know that? Overhead! An expense. You cost me two hundred and seventy thousand dollars a year to do the job a twenty-five-year-old accountant out of Illinois State could do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go to hell,” Marken said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll have none of that!” Helmut slapped his desk and pointed at Marken. “We must remain professional and show due respect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Charlie turned back to him. “Listen, Helmut, I need more time. I’m turning it around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Helmut paused and touched his forehead with a couple of fingers, an unfamiliar look of concern in his eyes. When he spoke again, his voice had softened and held no trace of its usual metallic edge. “I am sorry this did not work out, Charlie. This was all a mistake. I know you tried. I know you did your best. I know that. I know we put you in a difficult situation, but things have gotten much, much worse under your leadership. We have no choice. Thank you, and I wish you well. I sincerely do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Helmut, please, come on!” Charlie’s voice caught and they both looked away, Helmut down at the desk and Charlie out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Behind him, he heard the rustling of paper. Out of the corner of his eye, he saw Julie approaching, a descending angel of death, coming to take him away. He didn’t move, though. He kept staring out the window, into the sunlight and the air and into nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Charlie?” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("After they fired him and after Julie from human resources gave him an envelope with his separation package, and after she asked for his company BlackBerry and cell phone and American Express card and office passkey, and after she asked him where she should ship his telescope and globe and gumball machine, and after he took his little gold clock the old agency had given him when he left them, Charlie took a cab to the nearest zoo.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he got there, he walked. He wasn’t exactly sure why he chose to go to the zoo, though it was the one place where he was sure not to run into anyone from the agency. He walked for a long time, passing cages and fountains, the monkey house, and pockets of children clutching snow cones, lunch boxes, and balloons. He thought and felt nothing, other than wondering how long the shock would last and hoping that, with luck, it might last forever. If he were a drinker, he would have been in a bar; if he were a womanizer, he would be in someone’s arms; if he were a fighter, he would be with attorneys; if he were happily married, he would be at home. Instead, he was approaching walrus island.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wandered all over the zoo, oblivious to his surroundings, Helmut’s words, “This was all a mistake,” trailing him. He thought of things he should have said to him, made a list of reasons why he deserved more time. Alone, at the Lincoln Park Zoo, he made a passionate case.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was making progress. They had new business prospects. The staff would have come around and accepted him as the boss. He was on the verge of hiring a few key people who would shore up their weaknesses. He was only on the job for twelve months. The place was a disaster when he took over.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His anger was tempered by equal doses of shame and self-reproach. He should have seen this coming. He knew he was failing, knew that while he fiddled with book clubs and “fat” memos, Rome was burning, and brightly. He suspected that he should have stayed at the old agency making Bagel Man commercials with Bob Dole. Maybe, by now, they’d be working with one of the Clintons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mind raced erratically—money, his reputation, his mole—before stopping, exhausted, at his family: Donna and Kyle. How would they react? How would he tell them? What would he tell them? He walked on, one foot before the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lost track of time but eventually saw long shadows and got the sense it was late. Rather than check his watch, he pulled out his gold clock. It was small and circular and had a cover that slid off to reveal the time. He traced his engraved initials with a finger, then returned the clock to his pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He finally found himself on a bench near the lion cage. The light was fading and the wind was blowing stronger. Dark clouds formed overhead, moving quickly into each other, thick, gray. He realized that what he had thought was evening was really an approaching storm. He looked around, noticed he was alone, saw the lions slipping into their caves, casually glancing over their shoulders one last time before disappearing. Still, he sat there and waited for the rain, and when it came, he let it wash over him, let it run down the sides of his face and mingle with his tears.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20eaef40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312365486_ch03.vue
// module id = 72
// module chunks = 0